import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createVNode as _createVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["role", "aria-live"]
const _hoisted_2 = {
  class: "app-toast__icon",
  "aria-hidden": "true"
}
const _hoisted_3 = { class: "app-toast__body" }
const _hoisted_4 = {
  key: 0,
  class: "app-toast__title"
}
const _hoisted_5 = {
  key: 1,
  class: "app-toast__text"
}
const _hoisted_6 = {
  key: 0,
  class: "app-toast__progress",
  "aria-hidden": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckCircleFilled = _resolveComponent("CheckCircleFilled")!
  const _component_CloseCircleFilled = _resolveComponent("CloseCircleFilled")!
  const _component_ExclamationCircleFilled = _resolveComponent("ExclamationCircleFilled")!
  const _component_InfoCircleFilled = _resolveComponent("InfoCircleFilled")!
  const _component_CloseOutlined = _resolveComponent("CloseOutlined")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["app-toast", [`app-toast--${_ctx.kind}`, { 'app-toast--single-line': _ctx.isSingleLine, 'app-toast--timed': _ctx.lifeMs > 0 }]]),
    role: _ctx.isUrgent ? 'alert' : 'status',
    "aria-live": _ctx.isUrgent ? 'assertive' : 'polite'
  }, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.kind === 'success')
        ? (_openBlock(), _createBlock(_component_CheckCircleFilled, { key: 0 }))
        : (_ctx.kind === 'error')
          ? (_openBlock(), _createBlock(_component_CloseCircleFilled, { key: 1 }))
          : (_ctx.kind === 'warning')
            ? (_openBlock(), _createBlock(_component_ExclamationCircleFilled, { key: 2 }))
            : (_openBlock(), _createBlock(_component_InfoCircleFilled, { key: 3 }))
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.item.title)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.item.title), 1))
        : _createCommentVNode("", true),
      (_ctx.item.text)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.item.text), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("button", {
      type: "button",
      class: "app-toast__close",
      "aria-label": "Dismiss notification",
      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["stop"]))
    }, [
      _createVNode(_component_CloseOutlined)
    ]),
    (_ctx.lifeMs > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("span", {
            class: "app-toast__progress-fill",
            style: _normalizeStyle({ animationDuration: `${_ctx.lifeMs}ms` })
          }, null, 4)
        ]))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}